import "./main.scss";
import React, { useState, useRef } from "react";
import Feature from "./Feature";
import exportAsImage from "./exportAsImage";
import Message from "./message.svg";
import Instagram from "./instagram.svg";
import Phone from "./phone.svg";
import Telegram from "./telegram.svg";



function App() {
	const exportRef = useRef();
	const [priceA4, setPriceA4] = useState(0);
	const [priceA4Color, setPriceA4Color] = useState(0);
	const [priceA5, setPriceA5] = useState(0);
	const [priceA5Color, setPriceA5Color] = useState(0);
	const [text, setText] = useState("");
	const [button, setButton] = useState(true);
	const [message, setMessage] = useState("");
	const [isVisible, setVisible] = useState(false);

	let pricePerPage = 260;
	let pricePerPageColor = 370;
	let coverPrice = 0;

	// const handlePrice = (text) => {
	// 	let pages = text;
	// 	let bookNum;
	// 	if(text > 440 && text < 781){
	// 		bookNum = 2;
	// 	} else if (text > 780){
	// 		bookNum = Math.ceil((text - 780) / 390) + 2;
	// 	} else bookNum = 1;
	// 	text = Math.ceil(text / bookNum);
	// 	coverPrice = text >= 53 && text <= 129
	// 		? 16500
	// 		: text >= 130 && text <= 200
	// 			? 17500
	// 			: text >= 201 && text <= 300
	// 				? 18500
	// 				: text >= 301 && text <= 400
	// 					? 19500
	// 					: text >= 401 && text <= 440
	// 						? 20500 : 0;
	// 	let calcPriceA5 = (Math.ceil(text / 4) * pricePerPage + coverPrice + 1500) * bookNum;
	// 	calcPriceA5 = calcPriceA5 % 500 ? Math.ceil(calcPriceA5 / 500) * 500 : calcPriceA5;
	// 	setPriceA5(calcPriceA5);
	// 	let calcPriceA5Color = (Math.ceil(text / 4) * pricePerPageColor + coverPrice + 2000) * bookNum;
	// 	calcPriceA5Color = calcPriceA5Color % 500 ? Math.ceil(calcPriceA5Color / 500) * 500 : calcPriceA5Color;
	// 	setPriceA5Color(calcPriceA5Color);
	// 	let calcPriceA4 = (Math.ceil(text / 2) * pricePerPage + coverPrice + 1500) * bookNum;
	// 	calcPriceA4 = calcPriceA4 % 500 ? Math.ceil(calcPriceA4 / 500) * 500 : calcPriceA4;
	// 	setPriceA4(calcPriceA4);
	// 	let calcPriceA4Color = (Math.ceil(text / 2) * pricePerPageColor + coverPrice + 1500) * bookNum;
	// 	calcPriceA4Color = calcPriceA4Color % 500 ? Math.ceil(calcPriceA4Color / 500) * 500 : calcPriceA4Color;
	// 	setPriceA4Color(calcPriceA4Color);
	// 	setMessage(`Sahifalar soni: ${pages} ta  va Pereplyotlar soni: ${bookNum} ta`);
	// };

	// const handleText = (e) => {
	// 	if (text === "") {
	// 		setMessage(null);
	// 		setButton(true);
	// 	} else if (text !== "" && isNaN(text)) {
	// 		setButton(true);
	// 		setMessage("Sahifalar soni faqat raqamlardan va kamida 10 bet bo'lishi kerak !!!");
	// 		setText("440");
	// 	} else {
	// 		setButton(false);
	// 		setMessage(null);
	// 	}
	// 	setText(e.target.value);
	// };

	// const handleSubmit = (e) => {
	// 	e.preventDefault();

	// 	if (text >= 0 && text <= 52) {
	// 		setPriceA5(18500);
	// 		setPriceA4(21500);
	// 		setPriceA5Color(20000);
	// 		setPriceA4Color(24000);
	// 		setVisible(true);
	// 	}
	// 	if (text >= 53) {
	// 		handlePrice(text);
	// 		setVisible(true);
	// 	}

	// };

	function handleFile() {
		let input = document.getElementById("file");
		const file = input.files[0];
		let reader = new FileReader();
		reader.readAsBinaryString(file);
		reader.onloadend = function(){
			let count = reader.result.match(/\/Type[\s]*\/Page[^s]/g).length;
			setText(count + "");
		}
		setButton(false);
	}

	const [language, setLanguage] = useState("uz");

	const translations = {
		uz: {
			title: "WePrint",
			subtitle: "Biz bilan kitob chiqarish yanada oson",
			upload: "File yuklash",
			inputPlaceholder: "Sahifa sonini kiriting",
			calculate: "Hisoblash",
			screenshot: "Screenshot",
			a4Color: "A4, rangli",
			a4BW: "A4, oq-qora",
			a5Color: "A5, rangli",
			a5BW: "A5, oq-qora",
			commentA4: "** A4 format -- bu to'liq list hajmi.",
			commentA5: "** A5 format -- bu to'liq list hajmining yarmi.",
			messagePages: (pages, bookNum) => `Sahifalar soni: ${pages} ta  va Pereplyotlar soni: ${bookNum} ta`,
			messageInvalid: "Sahifalar soni faqat raqamlardan va kamida 10 bet bo'lishi kerak !!!",
			contactPhone: "Telefon",
			contactMessage: "Xabar",
			contactTelegram: "Telegram",
			contactInstagram: "Instagram",
			price: "Narxi: ",
			feature: "Xususiyatlari: "
		},
		en: {
			title: "WePrint",
			subtitle: "Printing books made easier with us",
			upload: "Upload file",
			inputPlaceholder: "Enter number of pages",
			calculate: "Calculate",
			screenshot: "Screenshot",
			a4Color: "A4, color",
			a4BW: "A4, black & white",
			a5Color: "A5, color",
			a5BW: "A5, black & white",
			commentA4: "** A4 format -- full sheet size.",
			commentA5: "** A5 format -- half of full sheet size.",
			messagePages: (pages, bookNum) => `Number of pages: ${pages} and Number of bindings: ${bookNum}`,
			messageInvalid: "Number of pages must be digits and at least 10 pages!",
			contactPhone: "Phone",
			contactMessage: "Message",
			contactTelegram: "Telegram",
			contactInstagram: "Instagram",
			price: "Price: ",
			feature: "Features: "
		},
		ru: {
			title: "WePrint",
			subtitle: "С нами печать книг проще",
			upload: "Загрузить файл",
			inputPlaceholder: "Введите количество страниц",
			calculate: "Рассчитать",
			screenshot: "Скриншот",
			a4Color: "A4, цветной",
			a4BW: "A4, чёрно-белый",
			a5Color: "A5, цветной",
			a5BW: "A5, чёрно-белый",
			commentA4: "** Формат A4 -- это полный размер листа.",
			commentA5: "** Формат A5 -- это половина полного листа.",
			messagePages: (pages, bookNum) => `Количество страниц: ${pages} и Количество переплетов: ${bookNum}`,
			messageInvalid: "Количество страниц должно быть числом и не менее 10!",
			contactPhone: "Телефон",
			contactMessage: "Сообщение",
			contactTelegram: "Телеграм",
			contactInstagram: "Инстаграм",
			price: "Цена: ",
			feature: "Особенности: "
		},
	};

	const t = translations[language];

	const handlePrice = (text) => {
		let pages = text;
		let bookNum;
		if(text > 440 && text < 781){
			bookNum = 2;
		} else if (text > 780){
			bookNum = Math.ceil((text - 780) / 390) + 2;
		} else bookNum = 1;
		text = Math.ceil(text / bookNum);
		coverPrice = text >= 53 && text <= 129
			? 16500
			: text >= 130 && text <= 200
				? 17500
				: text >= 201 && text <= 300
					? 18500
					: text >= 301 && text <= 400
						? 19500
						: text >= 401 && text <= 440
							? 20500 : 0;
		let calcPriceA5 = (Math.ceil(text / 4) * pricePerPage + coverPrice + 4000) * bookNum;
		calcPriceA5 = calcPriceA5 % 500 ? Math.ceil(calcPriceA5 / 500) * 500 : calcPriceA5;
		setPriceA5(calcPriceA5);
		let calcPriceA5Color = (Math.ceil(text / 4) * pricePerPageColor + coverPrice + 5000) * bookNum;
		calcPriceA5Color = calcPriceA5Color % 500 ? Math.ceil(calcPriceA5Color / 500) * 500 : calcPriceA5Color;
		setPriceA5Color(calcPriceA5Color);
		let calcPriceA4 = (Math.ceil(text / 2) * pricePerPage + coverPrice + 3500) * bookNum;
		calcPriceA4 = calcPriceA4 % 500 ? Math.ceil(calcPriceA4 / 500) * 500 : calcPriceA4;
		setPriceA4(calcPriceA4);
		let calcPriceA4Color = (Math.ceil(text / 2) * pricePerPageColor + coverPrice + 3500) * bookNum;
		calcPriceA4Color = calcPriceA4Color % 500 ? Math.ceil(calcPriceA4Color / 500) * 500 : calcPriceA4Color;
		setPriceA4Color(calcPriceA4Color);
		setMessage(t.messagePages(pages, bookNum));
	};

	const handleText = (e) => {
		if (text === "") {
			setMessage(null);
			setButton(true);
		} else if (text !== "" && isNaN(text)) {
			setButton(true);
			setMessage(t.messageInvalid);
			setText("440");
		} else {
			setButton(false);
			setMessage(null);
		}
		setText(e.target.value);
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		if (text >= 0 && text <= 52) {
			setPriceA5(21000);
			setPriceA4(23500);
			setPriceA5Color(23000);
			setPriceA4Color(26000);
			setVisible(true);
		}
		if (text >= 53) {
			handlePrice(text);
			setVisible(true);
		}
	};

	function handleFile() {
		let input = document.getElementById("file");
		const file = input.files[0];
		let reader = new FileReader();
		reader.readAsBinaryString(file);
		reader.onloadend = function(){
			let count = reader.result.match(/\/Type[\s]*\/Page[^s]/g).length;
			setText(count + "");
		}
		setButton(false);
	}

	return (
		<div className="App">
			<form className="calculation" onSubmit={handleSubmit} ref={exportRef}>
				<h1>{t.title}</h1>
				<h2>{t.subtitle}</h2>
				{/* <label className="custom-file-upload">
					{t.upload}
					<input type="file" placeholder={t.upload} id="file" onChange={handleFile} />
				</label> */}
				<div className="lang-switcher">
					<button onClick={() => setLanguage("uz")} disabled={language === "uz"}>UZ</button>
					<button onClick={() => setLanguage("ru")} disabled={language === "ru"}>RU</button>
					<button onClick={() => setLanguage("en")} disabled={language === "en"}>EN</button>
				</div>
				<input type="number" placeholder={t.inputPlaceholder} onChange={handleText} value={text} />
				<div className="btn-group">
					<button type="submit" disabled={button}>
						{t.calculate}
					</button>
					<button
						className="screenshot"
						onClick={() =>
							exportAsImage(
								exportRef.current,
								`WePrint_${Math.floor(Math.random() * 10000)}`)}>
						{t.screenshot}
					</button>
				</div>
				{message && <div className="message">{message}</div>}
				<div className={`info ${isVisible ? "show-it" : "nothing"}`}>
					<Feature text1={t.price} text2={t.feature} feature={t.a4Color} price={priceA4Color} />
					<Feature text1={t.price} text2={t.feature} color="no" feature={t.a4BW} price={priceA4} />
					<Feature text1={t.price} text2={t.feature} feature={t.a5Color} price={priceA5Color} />
					<Feature text1={t.price} text2={t.feature} color="no" feature={t.a5BW} price={priceA5} />
					<div className="comment">
						<p>{t.commentA4}</p>
						<p>{t.commentA5}</p>
					</div>
				</div>
			</form>
			<div className="calculation">
				<div className="map">
					<iframe
						title="uniqua;slkdjf;alksdjf"
						src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d5993.851118826498!2d69.246204!3d41.310483!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDHCsDE4JzM3LjciTiA2OcKwMTQnNDYuMyJF!5e0!3m2!1sen!2s!4v1684607694203!5m2!1sen!2s"
						loading="lazy"
						referrerPolicy="no-referrer-when-downgrade"
					></iframe>
				</div>
				<ul className="links">
					<li>
						<a href="tel:+998977234353" target="_blank">
							<img src={Phone} alt="phone" />
						</a>
					</li>
					<li>
						<a href="https://t.me/weprint_bot" target="_blank">
							<img src={Message} alt="message" />
						</a>
					</li>
					<li>
						<a href="https://t.me/weprint" target="_blank">
							<img src={Telegram} alt="telegram" />
						</a>
					</li>
					<li>
						<a href="https://www.instagram.com/weprint_uz/" target="_blank">
							<img src={Instagram} alt="insta" />
						</a>
					</li>
				</ul>
			</div>
		</div>
	);
}

export default App;
